import { render, staticRenderFns } from "./AsientosLiberadosCard.vue?vue&type=template&id=1ad8d138"
import script from "./AsientosLiberadosCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AsientosLiberadosCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports